import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import {
  EventReqDtos,
  HospitalCenterReqDto,
  LeadsDto,
} from '../../../api/interfaces/LeadsDto';
import { useLoader } from '../../../Loader/LoaderContext';
import { API_ENDPOINTS } from '../../../api';
import { getService } from '../../../servce/ApisService';
import { getEventTypes } from '../../../utility/RolesUtility';

const ViewDetails: React.FC = () => {
  const [data, setData] = useState<any>([]);
  const { setLoading } = useLoader();
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('appUserId');
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  useEffect(() => {
    fetchVehicles();
  }, []);

  const fetchVehicles = async () => {
    setLoading(true);
    try {
      const response = await getService(
        API_ENDPOINTS.proposalBooking + '?leadId=' + userId
      );
      console.log(response);
      setData(response.data);
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };
  const addedByName = searchParams.get('addedByName');
  const users = () => {
    if (path === '/portals/leads/ViewDetails') {
      navigate('/portals/leads/viewUser'); // Navigate to viewUser for Leads
    } else if (path === '/portals/vendors/activeVendor/ViewDetails') {
      navigate('/portals/vendors/activeVendor');
    } else if (path === '/portals/vendors/inActiveVendor/ViewDetails') {
      navigate('/portals/vendors/inActiveVendor');
    } else {
      navigate('/portals/proposals/viewProposal'); // Navigate to viewProposal for Proposals
    }
  };
  const usersScreen = () => {
    navigate(-1);
  };
  const editProfile = (data: any, actionType: string) => {
    if (path === '/portals/leads/ViewDetails') {
      navigate(
        `/portals/leads/addUser?appUserId=${data?.id}&name=${actionType}`
      );
    } else {
      navigate('/portals/proposals/addProposal?appUserId=' + data?.id);
    }
  };
  const addedName = () => {
    navigate(-1);
  };

  const leadTypeMapping: Record<string, string> = {
    COMPANY: 'Company',
    EVENT_ORGANIZER: 'Event Organiser',
    HOSPITAL: 'Hospital',
  };

  const getCenterSize: Record<string, string> = {
    SMALL: 'Small',
    MEDIUM: 'Medium',
    LARGE: 'Large',
  };

  const getleadType: Record<string, string> = {
    COMPANY: 'Company Name',
    EVENT_ORGANIZER: 'Event Organiser Name',
    HOSPITAL: 'Hospital Name',
  };

  const getSource: Record<string, string> = {
    INTERNAL: 'Internal',
    REFRAL: 'Refral',
    INBOUND_CALL: 'Inbound Call',
    INT_PROMOTIONS: 'Int Promotions',
    SOCIAL_MEDIA: 'Social Media',
    WEBSITE: 'Website',
  };

  return (
    <div className='h-full py-2 w-full'>
      <div className='flex items-center cursor-pointer mb-4'>
        <h2
          className='mr-2 text-gray-700 font-semibold text-sm'
          onClick={users}
        >
          {path === '/portals/leads/ViewDetails'
            ? 'Leads'
            : path === '/portals/vendors/activeVendor/ViewDetails' ||
              path === '/portals/vendors/inActiveVendor/ViewDetails'
            ? 'Vendors'
            : 'Proposals'}
        </h2>{' '}
        {addedByName && (
          <>
            <img src='/images/arrowIcons.svg' className='mr-2' />{' '}
            <span
              className='text-gray-700 font-semibold text-sm mr-2'
              onClick={addedName}
            >
              {addedByName}'s team
            </span>
          </>
        )}{' '}
        <img src='/images/arrowIcons.svg' className='mr-2' />{' '}
        <span className='text-gray-400 font-semibold text-sm'>
          {data[0]?.companyName}
        </span>
      </div>
      <div className=' '>
        {data?.map((item: LeadsDto, index: number) => (
          <div className='mb-6 bg-white p-5 rounded-[8px]'>
            <div className='flex justify-between items-center pb-4'>
              <div className='flex items-center'>
                <div>
                  <div className='flex'>
                    <h2 className='text-gray-900 font-bold text-[20px] mr-3 break-words'>
                      {item?.companyName}
                    </h2>
                  </div>
                  <p className='text-gray-600 text-base mt-1'>{item?.email}</p>
                </div>
              </div>
              <div className='font-semibold'>
                # {item?.uuid}
                <p className='text-sm font-normal text-end'>
                  {item?.addedDate}
                </p>
              </div>
              {path !== '/portals/vendors/activeVendor/ViewDetails' &&
                path !== '/portals/vendors/inActiveVendor/ViewDetails' && (
                  <div
                    className='border border-gray-300 py-2 px-4 text-gray-600 font-bold text-base rounded-[8px] cursor-pointer'
                    onClick={() => editProfile(data, 'edit')}
                  >
                    {path === '/portals/leads/ViewDetails'
                      ? 'Edit Lead'
                      : 'Edit Proposal'}
                  </div>
                )}
            </div>
            <p className='border border-gray-200'></p>

            <>
              <div className='grid grid-cols-3 py-5'>
                <div className='py-3'>
                  <h2 className='text-gray-700 font-normal text-sm'>Email</h2>
                  <p className='text-base font-semibold text-gray-900 break-words'>
                    {item?.email ? item?.email : 'NA'}
                  </p>
                </div>
                <div className='py-3 ml-5'>
                  <h2 className='text-gray-700 font-normal text-sm '>
                    Contact Person Name
                  </h2>
                  <p className='text-base font-semibold text-gray-900 break-words'>
                    {item?.contactPersonName ? item?.contactPersonName : 'NA'}
                  </p>
                </div>
                <div></div>
                <div className='py-3'>
                  <h2 className='text-gray-700 font-normal text-sm '>
                    Designation
                  </h2>
                  <p className='text-base font-semibold text-gray-900 break-words'>
                    {item?.contactPersonRole ? item?.contactPersonRole : 'NA'}
                  </p>
                </div>
                <div className='py-3 ml-5'>
                  <h2 className='text-gray-700 font-normal text-sm'>
                    Continent
                  </h2>
                  <p className='text-base font-semibold text-gray-900'>
                    {item?.mtContinentDto?.name
                      ? item?.mtContinentDto?.name
                      : 'NA'}
                  </p>
                </div>
                <div></div>

                <div className='py-3'>
                  <h2 className='text-gray-700 font-normal text-sm'>
                    Lead Type
                  </h2>
                  <p className='text-base font-semibold text-gray-900 break-words'>
                    {item?.leadType
                      ? leadTypeMapping[item.leadType]
                      : item?.type
                      ? leadTypeMapping[item.type]
                      : 'NA'}
                  </p>
                </div>

                <div className='py-3 ml-5'>
                  <h2 className='text-gray-700 font-normal text-sm'>
                    {item?.leadType
                      ? getleadType[item.leadType]
                      : item?.type
                      ? getleadType[item.type]
                      : 'NA'}
                  </h2>
                  <p className='text-base font-semibold text-gray-900 break-words'>
                    {item?.companyName ? item?.companyName : 'NA'}
                  </p>
                </div>
                <div></div>
                <div className='py-3'>
                  <h2 className='text-gray-700 font-normal text-sm '>
                    Call Back Date
                  </h2>
                  <p className='text-base font-semibold text-gray-900'>
                    {item?.callBackDate ? item?.callBackDate : 'NA'}
                  </p>
                </div>
                <div className='py-3 ml-5'>
                  <h2 className='text-gray-700 font-normal text-sm'>
                    Contact Number
                  </h2>
                  <p className='text-base font-semibold text-gray-900 break-words'>
                    {item?.contactNo ? item?.contactNo : 'NA'}
                  </p>
                </div>
                <div></div>
                <div className='py-3'>
                  <h2 className='text-gray-700 font-normal text-sm '>
                    Direct Number
                  </h2>
                  <p className='text-base font-semibold text-gray-900 break-words'>
                    {item?.directNo ? item?.directNo : 'NA'}
                  </p>
                </div>

                <div className='py-3 ml-5'>
                  <h2 className='text-gray-700 font-normal text-sm'>Website</h2>
                  <p className='text-base font-semibold text-gray-900 break-words '>
                    {item?.website ? item?.website : 'NA'}
                  </p>
                </div>
                <div></div>
                <div className='py-3'>
                  <h2 className='text-gray-700 font-normal text-sm'>
                    Feedback
                  </h2>
                  <p className='text-base font-semibold text-gray-900 break-words'>
                    {item?.feedback ? item?.feedback : 'NA'}
                  </p>
                </div>

                {path === '/portals/leads/ViewDetails' ? (
                  <>
                    <div className='py-3 pl-5'>
                      <h2 className='text-gray-700 font-normal text-sm'>
                        Source
                      </h2>
                      <p className='text-base font-semibold text-gray-900 break-words'>
                        {item?.source ? getSource[item.source] : 'NA'}
                      </p>
                    </div>

                    <div></div>
                  </>
                ) : (
                  <>
                    <div className='py-3 ml-5'>
                      <h2 className='text-gray-700 font-normal text-sm break-words'>
                        Source
                      </h2>
                      <p className='text-base font-semibold text-gray-900 break-words'>
                        {item?.source ? getSource[item.source] : 'NA'}
                      </p>
                    </div>
                    <div></div>

                    {path === '/portals/leads/ViewDetails' ? (
                      <div className='py-3 pl-5'>
                        <h2 className='text-gray-700 font-normal text-sm '>
                          Source URL
                        </h2>
                        <p className='text-base font-semibold text-gray-900 break-words'>
                          {item?.sourceUrl ? item.sourceUrl : 'NA'}
                        </p>
                      </div>
                    ) : (
                      <div className='py-3'>
                        <h2 className='text-gray-700 font-normal text-sm '>
                          Source URL
                        </h2>
                        <p className='text-base font-semibold text-gray-900 break-words'>
                          {item?.sourceUrl ? item.sourceUrl : 'NA'}
                        </p>
                      </div>
                    )}
                    <div className='py-3 pl-5'>
                      <h2 className='text-gray-700 font-normal text-sm'>
                        Pitched By
                      </h2>
                      <p className='text-base font-semibold text-gray-900 break-words'>
                        {item?.pitchedBy ? item.pitchedBy : 'NA'}
                      </p>
                    </div>
                    <div></div>
                    <div className='py-3'>
                      <h2 className='text-gray-700 font-normal text-sm'>
                        Country
                      </h2>
                      <p className='text-base font-semibold text-gray-900'>
                        {item?.mtCountryDto?.name
                          ? item.mtCountryDto.name
                          : 'NA'}
                      </p>
                    </div>

                    <div className='py-3 pl-5'>
                      <h2 className='text-gray-700 font-normal text-sm '>
                        Address
                      </h2>
                      <p className='text-base font-semibold text-gray-900 break-words'>
                        {item?.address ? item.address : 'NA'}
                      </p>
                    </div>
                  </>
                )}
              </div>

              {item?.eventRespDtos?.length > 0 && (
                <div className='py-5 w-full'>
                  <p className='border border-gray-200'></p>
                  <h1 className='text-xl font-semibold text-gray-900 mb-5'>
                    Events
                  </h1>
                  {item?.eventRespDtos?.map(
                    (event: EventReqDtos, index: number) => (
                      <div
                        className='eventCard flex gap-5 p-5 w-full mb-5 bg-gray-100'
                        key={event.id}
                      >
                        <div className='w-1/5'>
                          <div className='w-full h-32'>
                            <img
                              src={
                                event?.imageDto?.documentUrl
                                  ? event?.imageDto?.documentUrl
                                  : '/images/eventImage-1.svg'
                              }
                              alt='eventImage-1'
                              className={`w-full ${
                                event?.imageDto?.documentUrl
                                  ? 'h-full object-cover'
                                  : 'h-auto'
                              }`}
                            />
                          </div>
                        </div>
                        <div>
                          <div className='grid grid-cols-4'>
                            <div className='pb-2'>
                              <h4 className='text-sm text-gray-900'>
                                Event Name
                              </h4>
                              <h1 className='text-lg font-semibold text-gray-900 break-all'>
                                {event?.name ? event?.name : 'NA'}
                              </h1>
                            </div>
                            <div className='pb-2 ml-5'>
                              <h4 className='text-sm text-gray-900 '>
                                Contact Person Name
                              </h4>
                              <h1 className='text-lg font-semibold text-gray-900 break-all'>
                                {event?.contactPersonName
                                  ? event?.contactPersonName
                                  : 'NA'}
                              </h1>
                            </div>
                            <div></div>
                            <div></div>
                            <div className='pb-2'>
                              <h4 className='text-sm text-gray-900'>
                                Event Type
                              </h4>
                              <h1 className='text-lg font-semibold text-gray-900'>
                                {getEventTypes(event?.type)}
                              </h1>
                            </div>
                            <div className='pb-2 ml-5'>
                              <h4 className='text-sm text-gray-900'>
                                Contact Person Email
                              </h4>
                              <h1 className='text-lg font-semibold text-gray-900 break-all'>
                                {event?.contactPersonEmail
                                  ? event?.contactPersonEmail
                                  : 'NA'}
                              </h1>
                            </div>
                            <div></div>
                            <div></div>
                            <div className='pb-2'>
                              <h4 className='text-sm text-gray-900'>
                                Event Country
                              </h4>
                              <h1 className='text-lg font-semibold text-gray-900'>
                                {event?.mtCountryDto?.name
                                  ? event?.mtCountryDto?.name
                                  : 'NA'}
                              </h1>
                            </div>
                            <div className='pb-2 ml-5'>
                              <h4 className='text-sm text-gray-900 '>
                                Phone Number
                              </h4>
                              <h1 className='text-lg font-semibold text-gray-900 break-all'>
                                {event?.phoneNo ? event?.phoneNo : 'NA'}
                              </h1>
                            </div>
                            <div></div>
                            <div></div>
                          </div>

                          <p className='font-semibold text-[#B00A2B] pb-2 break-all'>
                            Event Link - {event?.link ? event?.link : 'NA'}
                          </p>
                          <div className='flex items-center gap-4'>
                            <div className='flex items-center gap-2'>
                              <img
                                src='/images/dateIcon.svg'
                                alt='dateicon'
                                className='size-4'
                              />
                              <p className='text-gray-600 w-[204px]'>
                                {event?.startDate ? event?.startDate : 'NA'} to{' '}
                                {event?.endDate ? event?.endDate : 'NA'}
                              </p>
                            </div>
                            <div className='flex items-center gap-2'>
                              <img
                                src='/images/locationMark.svg'
                                alt='locationMark Icon'
                                className='size-4'
                              />
                              <p className='text-gray-600 break-all'>
                                {event?.venue}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              )}
            </>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ViewDetails;
